module.exports = __webpack_public_path__ + "static/media/left-arrow-slider.b0c5f43a.svg";